import * as React from 'react'

import { Code } from '../../code'

interface IInlineCodeRendererProps {
  value?: string
}

export default function InlineCodeRenderer({ value }: IInlineCodeRendererProps) {
  return <Code>{value}</Code>
}
